import {Directive, ElementRef, EventEmitter, HostListener, Output} from '@angular/core';

@Directive({
  selector: '[heightObserver]',
  standalone: true
})
export class HeightObserverDirective {
  @Output() heightChange = new EventEmitter<number>();

  constructor(private el: ElementRef) { }

  ngAfterViewInit() {
    this.emitHeight();
  }

  @HostListener('window:resize')
  onResize() {
    this.emitHeight();
  }

  private emitHeight() {
    const height = this.el.nativeElement.offsetHeight;
    this.heightChange.emit(height);
  }
}
